module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/venue-img-one-d115fde34cc68a22c433e0c5124b5218.jpg";